import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UzurvDirectivesModule } from '@uzurv/core';
import { MaterialModule } from '../../../app/material.module';
import { AlertDialogModule } from '../alert-dialog/alert-dialog.module';
import { AddTransitProgramHolidayScheduleComponent } from './add-transit-program-holiday-schedule-dialog.component';

@NgModule({
  declarations: [AddTransitProgramHolidayScheduleComponent],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, UzurvDirectivesModule, MaterialModule, AlertDialogModule],
  exports: [AddTransitProgramHolidayScheduleComponent]
})
export class AddTransitProgramHolidayScheduleModule {}
